import { useEffect, useState } from "react";

import { getQuickList } from "services/sosInventoryService/sosApi";

/**
 * @name    useCategories
 *
 * @summary get an array of category records, generally for use in populating
 *          select lists for transactions
 *
 * @returns (array) record data for categories
 */

export function useCategories() {
  const [records, setRecords] = useState(null);

  useEffect(() => {
    async function retrieveRecords() {
      const response = await getQuickList("category", { inTransaction: true });
      setRecords(response.data);
    }
    retrieveRecords();
  }, []);

  return records;
}
